export var ApplePayResultStatus = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  ERROR: 'error'
};
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/payment_methods/applepay/types.js
// module id = 594
// module chunks = 0 1